export default "__VITE_ASSET__AUTdw50Z__"